<template>
  <el-container
    id="container-productInfo-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/productInfo', query:{page:$route.query.frompage || 1} }">最新情報列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <!-- <form-content :form="form" style="margin-top: 80px;" /> -->

        <el-form label-width="160px" @submit.native.prevent>

        <el-tabs value="common" type="card">
          <el-tab-pane label="通用" name="common">
                  <el-form-item label="日期">
                    <el-date-picker v-model="form.Date" class="left" type="date" placeholder="請選擇日期"
                    :picker-options="pickerOptions"></el-date-picker>
                    <p class="hint">只能選擇2022與之後的日期</p>
                  </el-form-item>

                  <el-form-item label="類別">
                    <div class="w-100">
                      <el-select style="width: calc(100% - 50px);margin-right: 22px;" filterable v-model="form.TagID" :multiple="false" placeholder="請選擇類別">
                        <template slot="empty">
                          <p class="el-select-dropdown__empty">沒有資料</p>
                        </template>
                        <el-option
                          v-for="item in tags"
                          :key="'productInfoTag-'+item.ID"
                          :label="item['Title'+'Tw']"
                          :value="item.ID">
                        </el-option>
                      </el-select>
                      <el-button @click="openTagCreatorModal" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
                    </div>
                  </el-form-item>

          </el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="tw">
            <form-content :form="form" form-key="Tw"
              @title-changed="onTitleChanged"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <form-content :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
            <form-content :form="form" form-key="En"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
            <form-content :form="form" form-key="Jp"/>
          </el-tab-pane>
        </el-tabs>
        </el-form>

        <p class="auto-save-hint">{{autoSaveHint}}</p>
        <p class="url-hint">https://www.syunkaya.com.tw/productInfo/{{form.URLKey}}</p>

        <el-switch
          v-model="form.Tw.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-tooltip v-if="!isEdit" class="item" effect="dark" placement="top-start">
          <div slot="content">商品網址路徑為以下: https://www.syunkaya.com.tw/productInfo/{{form.URLKey}}</div>
          <el-button type="primary" class="btn-set-url" size="mini" @click="showURLEditor">設定網址</el-button>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

      <u-r-l-setting-modal :isShow="isShowUrlSetModal" @close="isShowUrlSetModal = false" :url-key="form.URLKey" @submit="onSetURLKey"/>
        <productInfo-tag-editor-modal :isShow="isShowTagAddeditModal" @close="isShowTagAddeditModal = false" @submitted="onTagAdded"/>

    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import FormContent from '@/data/productInfo/view/editor-form.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import URLSettingModal from '@/data/productInfo/view/url-setting-modal.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required
import ProductInfoTagEditorModal from '@/data/productInfoTag/view/editor-modal.vue'

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader,
    FormContent,
    URLSettingModal,
    ProductInfoTagEditorModal
  },
  data () {
    return {
      oriObj: {},
      form: {
        TagID: null,
        Date: moment().format(),
        IsActive: true,
        Tw: { Tags: [], IsActive: true, Date: moment().format() },
        Cn: { Tags: [], IsActive: true, Date: moment().format() },
        En: { Tags: [], IsActive: true, Date: moment().format() },
        Jp: { Tags: [], IsActive: true, Date: moment().format() }
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: '',
      // url key
      isShowUrlSetModal: false,
      isURLKeySetManually: false,

      pickerOptions: {
        disabledDate (time) {
          return time.getFullYear() < 2022
        }
      },

      isShowTagAddeditModal: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createProductInfo'
    },
    title () {
      return this.isEdit ? this.form.Tw.Title : '新增'
    },
    tags () {
      return this.$store.state.productInfoTag.list
    }
  },
  methods: {
    onTagAdded (tag) {
      this.form.TagID = tag.ID
      // this.toggleTag(tag.ID)
    },
    openTagCreatorModal () {
      this.isShowTagAddeditModal = true
    },
    /* url key 設置 */
    onTitleChanged () {
      if (this.isEdit) return
      if (!this.isURLKeySetManually) {
        this.form.URLKey = this.form.Tw.Title.replace(/\//g, '')
      }
    },
    onSetURLKey (urlKey) {
      this.isURLKeySetManually = true
      this.form.URLKey = urlKey
    },
    showURLEditor () {
      this.isShowUrlSetModal = true
    },
    /* end url key */
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }

      var payload = JSON.parse(JSON.stringify(this.form))

      delete payload.Tag

      // 通用欄位
      for (let key of this.languages) {
        if (payload[key].TagIDs)payload[key].Tags = this.$store.state.productInfoTag.list.filter(o => payload[key].TagIDs.includes(o.ID))

        payload[key].Contents = JSON.stringify(payload[key].contentJsonArr)
        payload[key].contentJsonArr = undefined

        payload[key].Images = JSON.stringify(payload[key].imagesJsonArr)
        if (payload[key].Images === '') payload[key].Images = '[]'
        payload[key].imagesJsonArr = undefined

        payload[key].IsActive = !!payload['Tw'].IsActive
        // payload[key].IsActive = !!payload.IsActive
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.productInfo.edit(this, payload)
        : this.$services.productInfo.add(this, payload)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        // 封面圖片
        if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true

        // 圖片編輯器
        for (let i in this.form[lang].contentJsonArr) {
          let obj = this.form[lang].contentJsonArr[i]
          if (!obj) continue
          if (obj.type === 'image' && obj.value.img instanceof Blob) {
            return true
          }
        }
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'productInfo-list', query: { page: this.$route.query.frompage || 1 } })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.productInfo.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.productInfo.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.productInfo.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown productInfo for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.URLKey) {
        errMsg = '請設定網址'
      } else if (!this.form.Tw.Title) {
        errMsg = '請輸入標題(繁中)'
      } else if (!this.form.En.Title) {
        errMsg = '請輸入標題(英文)'
      } else if (!this.form.Jp.Title) {
        errMsg = '請輸入標題(日文)'
      } else if (!this.form.Date) {
        errMsg = '請選擇日期'
      } else if (!this.form.TagID) {
        errMsg = '請選擇類別'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Title', 'Description']
      const syncKeys = ['TagIDs', 'Date', 'CoverImageURLX1', 'CoverImageURLX2', 'CoverImageURLX3']
      const contentJsonArr = this.form.Tw.contentJsonArr

      this.syncForm(syncKeys)

      // 每一次結束都先設定 isLoading=true，避免其中一個先完成而取消 loading
      let promises1 = this.translateForm(translateKeys).then(() => { this.isLoading = true })
      let promises2 = this.translateContentEditor(contentJsonArr).then(() => { this.isLoading = true })

      // 同步 images
      let langs = this.languages.filter(o => o !== 'Tw')
      let arrClone = this.form['Tw']['imagesJsonArr'] ? JSON.parse(JSON.stringify(this.form['Tw']['imagesJsonArr'])) : []
      for (let lang of langs) {
        this.$set(this.form[lang], 'imagesJsonArr', arrClone)
      }

      Promise.all([promises1, promises2]).then(() => {
        this.isLoading = false
      })
    }
  },
  created () {
    var formSource = null
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.productInfo.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.productInfo.list[idx]
        formSource = JSON.parse(JSON.stringify(this.oriObj))

        for (let key of this.languages) {
          formSource[key].TagIDs = formSource[key].Tags.map(o => o.ID)
        }
        this.form = formSource
      } else {
        console.error(`unknown productInfo for id ${id}`)
      }
    }

    // cache
    this.cacheKey = 'cache-productInfo-' + (this.isEdit ? this.oriObj.ID : 0)
    let cache = this.getCache()
    if (cache) {
      this.confirmLoadCache().then(result => {
        if (result !== 'loaded') return
        let cacheForm = JSON.parse(cache)
        for (let key of this.languages) {
          cacheForm[key].TagIDs = cacheForm[key].Tags.map(o => o.ID)
        }
        this.form = cacheForm
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>
